import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  public profileForm: any;
  submitted = false;

  constructor(private formBuilder: FormBuilder) { }

  ngOnInit(): void {


    this.profileForm = this.formBuilder.group({
      userid: ['', Validators.required],
      password: ['', Validators.required],
      recaptcha: ['', Validators.required],
      });
  }


  get f() { return this.profileForm.controls; }

  onSubmit() {
    this.submitted = true;

    if (this.profileForm.invalid) {
      return;
  }

    alert(JSON.stringify(this.profileForm.value));
    //console.log(this.aFormGroup.controls);
  }



  // onSubmit() {
  //   alert(JSON.stringify(this.profileForm.value));
  //   //console.log(this.aFormGroup.controls);
  // }

  handleSuccess(e: any) {
    console.log("ReCaptcha", e);
  }
}
